import { render, staticRenderFns } from "./writerInfo.vue?vue&type=template&id=2a575412&scoped=true&"
import script from "./writerInfo.vue?vue&type=script&lang=js&"
export * from "./writerInfo.vue?vue&type=script&lang=js&"
import style0 from "./writerInfo.vue?vue&type=style&index=0&id=2a575412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a575412",
  null
  
)

export default component.exports